package com.sddamico.draftmachine.pages.draft

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.sddamico.draftmachine.api.ApiException
import com.sddamico.draftmachine.api.apiJson
import com.sddamico.draftmachine.api.apiGet
import com.sddamico.draftmachine.api.apiPost
import com.sddamico.draftmachine.components.layouts.LoadingFrame
import com.sddamico.draftmachine.components.layouts.MobileFrame
import com.sddamico.draftmachine.components.sections.AppHeaderContentStyle
import com.sddamico.draftmachine.components.sections.AppHeaderStyle
import com.sddamico.draftmachine.components.widgets.PickOriginStamp
import com.sddamico.draftmachine.components.widgets.SelectableCard
import com.sddamico.draftmachine.data.DraftOrder
import com.sddamico.draftmachine.data.DraftStatus
import com.sddamico.draftmachine.data.ExternalProvider
import com.sddamico.draftmachine.data.PickOrigin
import com.sddamico.draftmachine.data.Sport
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmEffects
import com.sddamico.draftmachine.ds.DmSpacing
import com.sddamico.draftmachine.ds.DmType
import com.sddamico.draftmachine.ds.Icon
import com.sddamico.draftmachine.ds.IconWeight
import com.sddamico.draftmachine.ds.core.Avatar
import com.sddamico.draftmachine.ds.core.AvatarSize
import com.sddamico.draftmachine.ds.core.Badge
import com.sddamico.draftmachine.ds.core.BadgeTone
import com.sddamico.draftmachine.ds.core.Divider
import com.sddamico.draftmachine.ds.displayBlock
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.dmPanel
import com.sddamico.draftmachine.ds.dmStamp
import com.sddamico.draftmachine.ds.feedback.Toast
import com.sddamico.draftmachine.ds.feedback.ToastTone
import com.sddamico.draftmachine.ds.forms.Button
import com.sddamico.draftmachine.ds.forms.ButtonSize
import com.sddamico.draftmachine.ds.forms.ButtonVariant
import com.sddamico.draftmachine.ds.forms.IconButton
import com.sddamico.draftmachine.ds.forms.Input
import com.sddamico.draftmachine.ds.forms.InputSize
import com.sddamico.draftmachine.ds.forms.Select
import com.sddamico.draftmachine.ds.forms.Switch
import com.sddamico.draftmachine.ds.motion.Motion
import com.sddamico.draftmachine.ds.motion.Presence
import com.sddamico.draftmachine.ds.motion.TransitionRole
import com.sddamico.draftmachine.ds.motion.ViewTransitions
import com.sddamico.draftmachine.ds.motion.transitionRole
import com.sddamico.draftmachine.ds.navigation.Cog
import com.sddamico.draftmachine.ds.navigation.StepItem
import com.sddamico.draftmachine.ds.navigation.Stepper
import com.sddamico.draftmachine.ds.roleH1
import com.sddamico.draftmachine.ds.roleH3
import com.sddamico.draftmachine.models.AddTeamToDraftRequest
import com.sddamico.draftmachine.models.CreateDraftRequest
import com.sddamico.draftmachine.models.CreateLeagueRequest
import com.sddamico.draftmachine.models.DraftResponse
import com.sddamico.draftmachine.models.FantraxLeagueOption
import com.sddamico.draftmachine.models.FantraxTeamOption
import com.sddamico.draftmachine.models.EspnLeaguePreview
import com.sddamico.draftmachine.models.PlayerPoolDetailResponse
import com.sddamico.draftmachine.models.LeagueCardResponse
import com.sddamico.draftmachine.models.LeagueResponse
import com.sddamico.draftmachine.models.LotteryConfigEntry
import com.sddamico.draftmachine.models.LotteryStateResponse
import com.sddamico.draftmachine.models.OrderEntry
import com.sddamico.draftmachine.models.PickResponse
import com.sddamico.draftmachine.models.PlayerPoolResponse
import com.sddamico.draftmachine.models.SetDraftOrderRequest
import com.sddamico.draftmachine.models.SuccessResponse
import com.sddamico.draftmachine.models.TeamResponse
import com.sddamico.draftmachine.util.transitionTo
import kotlinx.browser.window
import com.sddamico.draftmachine.pages.pools.PoolPickerModal
import com.sddamico.draftmachine.pages.pools.formatCount
import com.sddamico.draftmachine.pages.pools.sportIcon
import com.sddamico.draftmachine.util.EspnLookupRequest
import com.sddamico.draftmachine.util.fetchLeagueConnection
import com.sddamico.draftmachine.util.LoadState
import com.sddamico.draftmachine.util.LookupLeaguesResult
import com.sddamico.draftmachine.util.LookupTeamsResult
import com.sddamico.draftmachine.util.LookupEspnLeagueResult
import com.sddamico.draftmachine.util.LotteryActionResult
import com.sddamico.draftmachine.util.SaveConnectionResult
import com.sddamico.draftmachine.util.saveLeagueConnection
import com.sddamico.draftmachine.util.saveLotteryConfig
import com.sddamico.draftmachine.util.StartDraftResult
import com.sddamico.draftmachine.util.UNREACHABLE_MESSAGE
import com.sddamico.draftmachine.util.isValidEmail
import com.sddamico.draftmachine.util.lookupFantraxLeagues
import com.sddamico.draftmachine.util.lookupFantraxTeams
import com.sddamico.draftmachine.util.lookupEspnLeague
import com.sddamico.draftmachine.util.rememberAuthState
import com.sddamico.draftmachine.util.rememberDashboard
import com.sddamico.draftmachine.util.sportLabel
import com.sddamico.draftmachine.util.startDraft
import com.sddamico.draftmachine.util.triggerOwnershipSync
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import kotlinx.serialization.builtins.ListSerializer
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Text

/**
 * The start-a-draft wizard (design frames 1h–1l). Four client-side steps (League → Teams →
 * Format → Start); nothing is persisted until step 4, where the whole draft is created in one
 * sequence. Route: `/draft/new`.
 */
@Page
@Composable
fun NewDraftPage() {
  val ctx = rememberPageContext()
  val scope = rememberCoroutineScope()
  val auth = rememberAuthState()

  when (val s = auth.value) {
    is LoadState.Loading -> LoadingFrame()
    is LoadState.Failed -> {
      LaunchedEffect(Unit) { ctx.router.transitionTo("/login") }
      LoadingFrame()
    }
    is LoadState.Ready -> {
      val user = s.value
      if (user == null) {
        LaunchedEffect(Unit) { ctx.router.transitionTo("/login") }
        LoadingFrame()
      } else {
        Wizard(email = user.email, ctx = ctx, scope = scope)
      }
    }
  }
}

// ── Wizard shell ──

private val WIZ_STEPS = listOf(
  StepItem("League"), StepItem("Teams"), StepItem("Format"), StepItem("Start"),
)

/**
 * The wizard's screens. The lottery flow inserts three sub-steps between Format and Review that
 * render under the Stepper's "Format" cog ([stepperIndex] stays 2).
 */
internal enum class WizPhase(val stepperIndex: Int) {
  League(0), Teams(1), Format(2),
  LotteryWeights(2), LotteryProcessing(2), LotteryOrder(2),
  Review(3),
}

@Composable
private fun Wizard(email: String, ctx: PageContext, scope: CoroutineScope) {
  val state = remember { WizardState() }

  // `/draft/new?resume={draftId}` — rehydrate an in-flight lottery from the server and land on the
  // processing step. One GET carries everything (teams, weights, revealed draws, draft context).
  val resumeId = ctx.route.params["resume"]
  var hydrating by remember { mutableStateOf(resumeId != null) }
  if (resumeId != null) {
    LaunchedEffect(resumeId) {
      try {
        val lottery = apiGet("/api/draft-lottery?draftId=$resumeId", LotteryStateResponse.serializer())
        if (lottery.draftStatus != DraftStatus.SETUP) {
          ctx.router.transitionTo("/draft/$resumeId")
          return@LaunchedEffect
        }
        state.hydrateFromLottery(lottery)
        hydrating = false
      } catch (e: Throwable) {
        // Missing lottery, no access, or unreachable — the draft room is the right fallback.
        ctx.router.transitionTo("/draft/$resumeId")
      }
    }
  }
  if (hydrating) {
    LoadingFrame()
    return
  }

  // `/draft/new?poolId={id}` — arrived via a pool page's "Use in a draft"; preselect that pool.
  val presetPoolId = ctx.route.params["poolId"]
  if (presetPoolId != null) {
    LaunchedEffect(presetPoolId) {
      try {
        val detail = apiGet("/api/player-pool-detail?poolId=$presetPoolId", PlayerPoolDetailResponse.serializer())
        state.selectPool(detail.pool.copy(totalPlayerCount = detail.totalPlayerCount))
      } catch (_: Throwable) {
        // Pool unavailable — the wizard simply starts with no pool selected.
      }
    }
  }
  // Managed leagues drive step 1's existing-league picker (you can only draft in leagues you run).
  // A resumed lottery never shows step 1, so skip the dashboard fetch entirely on that path.
  val dashboardState = if (resumeId == null) rememberDashboard() else LoadState.Ready(emptyList())
  val managedLeagues: List<LeagueCardResponse> = when (dashboardState) {
    is LoadState.Ready -> remember(dashboardState.value) { dashboardState.value.filter { it.youManage } }
    else -> emptyList()
  }

  // With no league to pick, the "spin up a new league" card is the only thing on step 1 —
  // expand it straight to the inputs rather than making the user tap a header first.
  LaunchedEffect(dashboardState) {
    if (dashboardState is LoadState.Ready && managedLeagues.isEmpty() && state.selectedLeagueId == null) {
      state.creatingNew = true
    }
  }

  // Existing leagues inherit the roster from their most recently created draft. Keep this tied
  // to the selected league so switching cards while a request is in flight cannot import the
  // previous card's teams.
  LaunchedEffect(state.selectedLeagueId, managedLeagues) {
    val leagueId = state.selectedLeagueId ?: return@LaunchedEffect
    val latestDraftId = managedLeagues.firstOrNull { it.league.id == leagueId }
      ?.latestDraft?.draftId
    if (latestDraftId == null) {
      state.finishTeamImport(leagueId, emptyList())
      return@LaunchedEffect
    }
    try {
      val teams = apiGet(
        "/api/draft-teams?draftId=$latestDraftId",
        ListSerializer(TeamResponse.serializer()),
      )
      state.finishTeamImport(leagueId, teams)
    } catch (e: Throwable) {
      state.failTeamImport(leagueId, e.message ?: UNREACHABLE_MESSAGE)
    }
  }

  // A saved ESPN connection already knows its sport. Carry that identity into the draft instead
  // of asking the LM to repeat it, and pair it with the corresponding official catalog.
  LaunchedEffect(state.selectedLeagueId) {
    val leagueId = state.selectedLeagueId ?: return@LaunchedEffect
    val connectionState = fetchLeagueConnection(leagueId)
    val connection = (connectionState as? LoadState.Ready)?.value?.connection
      ?.takeIf { it.provider == ExternalProvider.ESPN }
      ?: return@LaunchedEffect
    val pool = fetchOfficialPool(connection.sport)
    state.applyLinkedEspnDefaults(leagueId, connection.sport, pool)
  }

  // A brand-new league connected to Fantrax seeds its roster from that league's teams. This lives
  // at the page level, not in step 1, so switching to step 2 mid-request doesn't cancel the fetch.
  LaunchedEffect(state.fantraxSelected) {
    val option = state.fantraxSelected ?: return@LaunchedEffect
    when (val result = lookupFantraxTeams(option.leagueId)) {
      is LookupTeamsResult.Success -> state.finishFantraxTeamImport(option.leagueId, result.teams, email)
      is LookupTeamsResult.Failure -> state.failFantraxTeamImport(option.leagueId, result.message)
    }
  }

  LaunchedEffect(state.espnSelected) {
    val preview = state.espnSelected ?: return@LaunchedEffect
    val pool = fetchOfficialPool(preview.sport)
    state.applyImportedEspnPool(preview.leagueId, preview.sport, pool)
  }

  fun submit(start: Boolean) {
    if (state.submitting) return
    state.submitting = true
    state.errorMsg = null
    scope.launch {
      try {
        runCreation(state, email, managedLeagues, start, ctx)
      } catch (e: ApiException) {
        state.errorMsg = e.errorMessage
        state.submitting = false
      } catch (e: Throwable) {
        state.errorMsg = e.message ?: UNREACHABLE_MESSAGE
        state.submitting = false
      }
    }
  }

  // "Process the lottery": persist everything (league/pool/draft/teams) plus the lottery config,
  // then move to the processing screen. The draw itself commits server-side at the first spin.
  fun processLottery() {
    if (state.submitting) return
    state.submitting = true
    state.errorMsg = null
    scope.launch {
      try {
        val draftId = ensureEntitiesCreated(state, email, managedLeagues)
        val entries = state.lotteryBaseOrder.mapIndexed { index, localId ->
          LotteryConfigEntry(
            teamId = state.createdIdMap.getValue(localId),
            weight = if (index < state.lotterySize) state.weightOf(localId) else null,
          )
        }
        when (val result = saveLotteryConfig(draftId, state.lotterySize, entries)) {
          is LotteryActionResult.Success -> {
            state.lotteryState = result.state
            state.goTo(WizPhase.LotteryProcessing)
          }
          is LotteryActionResult.Failure -> state.errorMsg = result.message
        }
        state.submitting = false
      } catch (e: ApiException) {
        state.errorMsg = e.errorMessage
        state.submitting = false
      } catch (e: Throwable) {
        state.errorMsg = e.message ?: UNREACHABLE_MESSAGE
        state.submitting = false
      }
    }
  }

  // The draw committed the pick order server-side, so the editor is seeded from what was actually
  // persisted rather than from a client-side replay of the lottery rules.
  fun loadLotteryOrder() {
    if (state.submitting) return
    val draftId = state.createdDraftId ?: return
    state.submitting = true
    state.errorMsg = null
    scope.launch {
      try {
        val picks = apiGet("/api/draft-order?draftId=$draftId", ListSerializer(PickResponse.serializer()))
        state.seedLotteryOrder(picks)
        state.goTo(WizPhase.LotteryOrder)
        state.submitting = false
      } catch (e: ApiException) {
        state.errorMsg = e.errorMessage
        state.submitting = false
      } catch (e: Throwable) {
        state.errorMsg = e.message ?: UNREACHABLE_MESSAGE
        state.submitting = false
      }
    }
  }

  // Leaving the order step saves in either direction — the order it edits is already live on the
  // server, so carrying changes in memory until Review would let a refresh silently revert them.
  fun saveLotteryOrder(next: WizPhase) {
    if (state.submitting) return
    if (!state.lotteryOrderDirty) {
      state.goTo(next)
      return
    }
    val draftId = state.createdDraftId ?: return
    // The baseline must be the list that was actually posted, not whatever customOrder holds when
    // the request returns — an edit landing mid-flight would otherwise be marked saved and dropped.
    val posted = state.customOrder
    state.submitting = true
    state.errorMsg = null
    scope.launch {
      try {
        apiPost(
          "/api/draft-order",
          apiJson.encodeToString(
            SetDraftOrderRequest.serializer(),
            SetDraftOrderRequest(draftId = draftId, entries = state.orderEntries(posted)),
          ),
          SuccessResponse.serializer(),
        )
        state.lotteryOrderBaseline = posted
        state.goTo(next)
        state.submitting = false
      } catch (e: ApiException) {
        state.errorMsg = e.errorMessage
        state.submitting = false
      } catch (e: Throwable) {
        state.errorMsg = e.message ?: UNREACHABLE_MESSAGE
        state.submitting = false
      }
    }
  }

  MobileFrame(
    modifier = Modifier.displayFlex().flexDirection(FlexDirection.Column),
    header = { WizardHeader(onClose = { ctx.router.transitionTo("/") }) },
  ) {
    Div(attrs = Modifier.padding(top = 18.px, leftRight = 16.px).toAttrs()) {
      Stepper(WIZ_STEPS, current = state.phase.stepperIndex, modifier = Modifier.transitionRole(TransitionRole.Stepper))
    }
    if (state.errorMsg != null) {
      Div(attrs = Modifier.padding(top = 12.px, leftRight = 16.px).toAttrs()) {
        Toast(
          title = "Couldn't finish", message = state.errorMsg, tone = ToastTone.Rust,
          onClose = { state.errorMsg = null },
        )
      }
    }
    when (state.phase) {
      WizPhase.League -> LeagueStep(state, managedLeagues, email, onCancel = { ctx.router.transitionTo("/") })
      WizPhase.Teams -> TeamsStep(state)
      WizPhase.Format -> FormatStep(state)
      WizPhase.LotteryWeights -> LotteryWeightsStep(state, onProcess = { processLottery() })
      WizPhase.LotteryProcessing -> LotteryProcessingStep(state, onContinue = { loadLotteryOrder() })
      WizPhase.LotteryOrder -> LotteryOrderStep(state, onLeave = { next -> saveLotteryOrder(next) })
      WizPhase.Review -> ReviewStep(state, managedLeagues, onStart = { submit(true) }, onSaveLater = { submit(false) })
    }
  }
}

/** Applies an edit to the wizard's lists so rows that arrive, leave or move are seen doing it. */
private fun WizardState.animate(edit: WizardState.() -> Unit) {
  ViewTransitions.run(Motion.Update) { edit() }
}

/**
 * Moves the wizard to [next], sliding the way the stepper reads: later steps arrive from the right,
 * earlier ones from the left. Each step opens at its top, where its heading is.
 */
internal fun WizardState.goTo(next: WizPhase) {
  if (next == phase) return
  val motion = if (next.ordinal > phase.ordinal) Motion.Forward else Motion.Back
  ViewTransitions.run(motion) {
    phase = next
    window.scrollTo(0.0, 0.0)
  }
}

@Composable
private fun WizardHeader(onClose: () -> Unit) {
  Div(
    attrs = AppHeaderStyle.toModifier()
      .transitionRole(TransitionRole.Header)
      .displayFlex().alignItems(AlignItems.Center)
      .borderBottom(1.px, LineStyle.Solid, DmColor.border)
      .backgroundColor(Color.rgba(22, 28, 34, 0.85f))
      .toAttrs()
  ) {
    Div(attrs = AppHeaderContentStyle.toModifier()
      .displayFlex().alignItems(AlignItems.Center).fillMaxWidth().toAttrs()) {
      Div(
        attrs = Modifier.displayFlex().alignItems(AlignItems.Center).cursor(Cursor.Pointer)
          .toAttrs {
            attr("role", "button"); attr("aria-label", "Close"); attr("title", "Close")
            onClick { onClose() }
          }
      ) {
        Icon("x", IconWeight.Bold, Modifier.fontSize(18.px).color(DmColor.textSecondary))
      }
      SpanText("New draft", Modifier.dmStamp().color(DmColor.textMuted))
    }
  }
}

/** Shared scrollable content column + footer used by each step. */
@Composable
internal fun StepColumn(gap: CSSLengthNumericValue = 12.px, content: @Composable () -> Unit) {
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(gap)
      .padding(top = 20.px, leftRight = 16.px, bottom = 8.px).toAttrs()
  ) { content() }
}

@Composable
internal fun StepFooter(content: @Composable () -> Unit) {
  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
      .gap(12.px).padding(16.px).margin(top = 14.px)
      .borderTop(1.px, LineStyle.Solid, DmColor.border).toAttrs()
  ) { content() }
}

@Composable
internal fun StepHeading(text: String) {
  SpanText(text, Modifier.roleH1().fontSize(24.px).displayBlock())
}

/** A `dmPanel()` box with a flex-column body — the wizard's repeated inline-panel shape. */
@Composable
internal fun PanelColumn(
  pad: CSSLengthNumericValue = 14.px,
  gap: CSSLengthNumericValue = 12.px,
  content: @Composable () -> Unit,
) {
  Div(
    attrs = Modifier.dmPanel().padding(pad).displayFlex().flexDirection(FlexDirection.Column).gap(gap).toAttrs()
  ) { content() }
}

// ── Step 1 · League (1h) ──

@Composable
private fun LeagueStep(
  state: WizardState,
  leagues: List<LeagueCardResponse>,
  email: String,
  onCancel: () -> Unit,
) {
  val scope = rememberCoroutineScope()

  fun lookupFantrax() {
    if (state.fantraxLooking || state.fantraxSecret.isBlank()) return
    state.fantraxLooking = true
    state.fantraxLookupError = null
    scope.launch {
      when (val result = lookupFantraxLeagues(state.fantraxSecret.trim())) {
        is LookupLeaguesResult.Success -> {
          state.fantraxOptions = result.leagues
          if (result.leagues.isEmpty()) {
            state.fantraxLookupError = "That secret id didn't return any leagues."
          }
        }
        is LookupLeaguesResult.Failure -> state.fantraxLookupError = result.message
      }
      state.fantraxLooking = false
    }
  }

  fun lookupEspn() {
    val sport = state.newLeagueSport
    val season = state.espnSeasonText.toIntOrNull()
    if (
      state.espnLooking || sport == null || season == null ||
      state.espnLeagueId.isBlank() || state.espnS2.isBlank() || state.espnSwid.isBlank()
    ) return
    val leagueId = state.espnLeagueId.trim()
    val espnS2 = state.espnS2.trim()
    val espnSwid = state.espnSwid.trim()
    val request = state.beginEspnLookup(leagueId, sport, season, espnS2, espnSwid)
    scope.launch {
      when (
        val result = lookupEspnLeague(leagueId, sport, season, espnS2, espnSwid)
      ) {
        is LookupEspnLeagueResult.Success -> if (
          state.isEspnLookupCurrent(request)
        ) {
          state.selectEspnLeague(result.league, email)
        }
        is LookupEspnLeagueResult.Failure -> if (
          state.isEspnLookupCurrent(request)
        ) {
          state.espnLookupError = result.message
        }
      }
      state.finishEspnLookup(request)
    }
  }

  StepColumn {
    StepHeading("Which league is drafting?")

    leagues.forEach { card ->
      val selected = state.selectedLeagueId == card.league.id
      SelectableCard(
        selected = selected,
        onClick = {
          state.selectExistingLeague(card.league.id, card.latestDraft != null)
        },
      ) {
        Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
          SpanText(
            card.league.name,
            Modifier.roleH3().displayBlock().color(if (selected) DmColor.brass300 else DmColor.text),
          )
          SpanText(
            leagueMeta(card),
            Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
              .displayBlock().margin(top = 3.px),
          )
        }
        if (selected) {
          Icon("check-circle", IconWeight.Fill, Modifier.fontSize(22.px).color(DmColor.brass400))
        }
      }
    }

    if (leagues.isNotEmpty()) Divider(label = "or")

    // Spin up a new league.
    SelectableCard(
      selected = state.creatingNew,
      dashed = true,
      onClick = {
        state.selectNewLeague()
      },
    ) {
      Icon("plus-circle", IconWeight.Bold, Modifier.fontSize(22.px).color(DmColor.brass400).flex("0 0 auto"))
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        SpanText(
          "Spin up a new league",
          Modifier.roleH3().displayBlock().color(if (state.creatingNew) DmColor.brass300 else DmColor.text),
        )
        SpanText(
          "Name it, pick a season — teams come next.",
          Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted)
            .displayBlock().margin(top = 2.px),
        )
      }
    }

    if (state.creatingNew) {
      PanelColumn {
        // Remounted when an external league fills these in: the DS Input takes its DOM value at mount,
        // and a <select> keeps whatever the user last chose regardless of the `selected` attribute.
        key(state.leagueFormNonce) {
          Input(
            label = "League name", icon = "trophy", placeholder = "Sunday Night Showdown",
            value = state.newLeagueName, onValueChange = { state.newLeagueName = it },
          )
          Select(
            label = "Season / sport",
            onValueChange = { state.setLeagueSport(if (it == MIXED_SPORT) null else Sport.valueOf(it)) },
          ) {
            Option(MIXED_SPORT, attrs = { if (state.newLeagueSport == null) attr("selected", "selected") }) {
              Text("Mixed / hybrid")
            }
            Sport.values().forEach { sp ->
              Option(sp.name, attrs = { if (state.newLeagueSport == sp) attr("selected", "selected") }) {
                Text(sportLabel(sp))
              }
            }
          }
        }

        ExternalConnectSection(state, onFantraxLookup = ::lookupFantrax, onEspnLookup = ::lookupEspn)
      }
    }
  }

  val externalReady = !state.connectExternal || when (state.externalProvider) {
    ExternalProvider.FANTRAX -> state.fantraxSelected != null
    ExternalProvider.ESPN -> state.espnSelected != null
  }
  val canNext = state.selectedLeagueId != null ||
    (state.creatingNew && state.newLeagueName.isNotBlank() && externalReady)
  StepFooter {
    Button("Cancel", variant = ButtonVariant.Ghost, onClick = onCancel)
    Button(
      "Next · Teams", variant = ButtonVariant.Primary, iconRight = "arrow-right",
      disabled = !canNext, onClick = { state.goTo(WizPhase.Teams) },
    )
  }
}

@Composable
private fun ExternalConnectSection(
  state: WizardState,
  onFantraxLookup: () -> Unit,
  onEspnLookup: () -> Unit,
) {
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px)
      .padding(top = 12.px).borderTop(1.px, LineStyle.Solid, DmColor.border).toAttrs()
  ) {
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center)
        .justifyContent(JustifyContent.SpaceBetween).gap(10.px).toAttrs()
      ) {
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        SpanText("Connect a fantasy league", Modifier.roleH3().fontSize(14.px).displayBlock())
        SpanText(
          "Optional — lets the draft room know who's already rostered.",
          Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted)
            .displayBlock().margin(top = 2.px),
        )
      }
      Switch(
        checked = state.connectExternal,
        onChange = { state.setConnectExternal(it) },
      )
    }

    if (!state.connectExternal) return@Div

    SpanText("INPUT SOURCE", Modifier.dmStamp().color(DmColor.brass300).displayBlock())
    Div(attrs = Modifier.displayFlex().gap(8.px).toAttrs()) {
      listOf(
        ExternalProvider.FANTRAX to ("Fantrax" to "broadcast"),
        ExternalProvider.ESPN to ("ESPN" to "television-simple"),
      ).forEach { (provider, copy) ->
        SelectableCard(
          selected = state.externalProvider == provider,
          onClick = { state.selectExternalProvider(provider) },
          modifier = Modifier.flex(1).padding(10.px),
          ariaLabel = "Use ${copy.first}",
        ) {
          Icon(copy.second, IconWeight.Bold, Modifier.fontSize(18.px).color(DmColor.brass400))
          SpanText(copy.first, Modifier.dmStamp().color(DmColor.text))
        }
      }
    }

    when (state.externalProvider) {
      ExternalProvider.FANTRAX -> FantraxConnectionFields(state, onFantraxLookup)
      ExternalProvider.ESPN -> EspnConnectionFields(state, onEspnLookup)
    }
  }
}

@Composable
private fun FantraxConnectionFields(state: WizardState, onLookup: () -> Unit) {
  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).toAttrs()) {

    val chosen = state.fantraxSelected
    if (chosen != null) {
      SelectableCard(selected = true, onClick = null) {
        Icon("check-circle", IconWeight.Fill, Modifier.fontSize(20.px).color(DmColor.brass400).flex("0 0 auto"))
        Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
          SpanText(chosen.leagueName, Modifier.roleH3().displayBlock().color(DmColor.brass300))
          SpanText(
            fantraxOptionMeta(chosen),
            Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
              .displayBlock().margin(top = 3.px),
          )
        }
      }
      // The roster import runs off this pick (see the LaunchedEffect in the page composable), so
      // report it here — it's what fills the next step.
      SpanText(
        when {
          state.importingTeams -> "Pulling this league's teams…"
          state.teamImportError != null -> "Couldn't pull the teams — add them by hand on the next step."
          state.teams.isNotEmpty() -> "${state.teams.size} teams imported — add owner emails next."
          else -> "No teams came back — add them by hand on the next step."
        },
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).displayBlock(),
      )
      Div(attrs = Modifier.displayFlex().justifyContent(JustifyContent.FlexEnd).toAttrs()) {
        Button(
          "Pick a different league", variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
          onClick = { state.clearFantraxLeague() },
        )
      }
      return@Div
    }

    // Toggling the section off unmounts this Input, so the DS Input's mount-time value sync is
    // enough to show the cleared secret when it comes back — no `key(...)` remount needed.
    Input(
      label = "Fantrax user secret id", icon = "key",
      hint = "From your Fantrax profile page. We use it to list your leagues.",
      error = state.fantraxLookupError,
      value = state.fantraxSecret,
      onValueChange = {
        state.fantraxSecret = it
        state.fantraxLookupError = null
      },
      onEnter = onLookup,
    )
    Div(attrs = Modifier.displayFlex().justifyContent(JustifyContent.FlexEnd).toAttrs()) {
      Button(
        "Find my leagues", icon = "magnifying-glass", variant = ButtonVariant.Secondary,
        size = ButtonSize.Sm, loading = state.fantraxLooking,
        disabled = state.fantraxSecret.isBlank(), onClick = onLookup,
      )
    }

    if (state.fantraxOptions.isNotEmpty()) {
      SpanText("PICK THE LEAGUE", Modifier.dmStamp().color(DmColor.brass300).displayBlock())
      state.fantraxOptions.forEach { option ->
        // A sport we don't model can't be stored on the connection, so the row stays inert
        // rather than failing later with a save error the LM can't act on.
        val supported = option.sport != null
        SelectableCard(
          selected = false,
          onClick = if (supported) ({ state.selectFantraxLeague(option) }) else null,
        ) {
          Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
            SpanText(
              option.leagueName,
              Modifier.roleH3().displayBlock().color(if (supported) DmColor.text else DmColor.textMuted),
            )
            SpanText(
              if (supported) fantraxOptionMeta(option) else "The Draft Machine doesn't handle that sport yet",
              Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
                .displayBlock().margin(top = 3.px),
            )
          }
        }
      }
    }
  }
}

@Composable
private fun EspnConnectionFields(state: WizardState, onLookup: () -> Unit) {
  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).toAttrs()) {
    val chosen = state.espnSelected
    if (chosen != null) {
      SelectableCard(selected = true, onClick = null) {
        Icon("check-circle", IconWeight.Fill, Modifier.fontSize(20.px).color(DmColor.brass400))
        Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
          SpanText(chosen.leagueName, Modifier.roleH3().displayBlock().color(DmColor.brass300))
          SpanText(
            "${sportLabel(chosen.sport)} · ${chosen.season} · ${chosen.teams.size} teams",
            Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock(),
          )
        }
      }
      SpanText(
        "${chosen.teams.size} teams imported with ESPN owner names — add missing emails next.",
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).displayBlock(),
      )
      Div(attrs = Modifier.displayFlex().justifyContent(JustifyContent.FlexEnd).toAttrs()) {
        Button(
          "Use a different league", variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
          onClick = { state.clearEspnLeague() },
        )
      }
      return@Div
    }

    Input(
      label = "ESPN league id", icon = "hash", placeholder = "362846",
      value = state.espnLeagueId,
      onValueChange = state::setEspnLeagueId,
    )
    Input(
      label = "ESPN season", icon = "calendar-blank", placeholder = "2026",
      hint = "NBA and NHL use the season-ending year shown in the ESPN league URL.",
      value = state.espnSeasonText,
      onValueChange = { state.setEspnSeason(it) },
    )
    Input(
      label = "espn_s2 cookie", icon = "key", type = "password",
      hint = "Copy the value from your signed-in ESPN browser cookies.",
      value = state.espnS2,
      onValueChange = state::setEspnS2,
    )
    Input(
      label = "SWID cookie", icon = "fingerprint", placeholder = "{...}",
      error = state.espnLookupError,
      value = state.espnSwid,
      onValueChange = state::setEspnSwid,
      onEnter = onLookup,
    )
    if (state.newLeagueSport == null) {
      SpanText(
        "Choose NFL, MLB, NBA, or NHL above before checking ESPN.",
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.rust300).displayBlock(),
      )
    }
    Div(attrs = Modifier.displayFlex().justifyContent(JustifyContent.FlexEnd).toAttrs()) {
      val supported = state.newLeagueSport in setOf(Sport.NFL, Sport.MLB, Sport.NBA, Sport.NHL)
      Button(
        "Check league", icon = "magnifying-glass", variant = ButtonVariant.Secondary,
        size = ButtonSize.Sm, loading = state.espnLooking,
        disabled = !supported || state.espnLeagueId.isBlank() || state.espnSeasonText.toIntOrNull() == null ||
          state.espnS2.isBlank() || state.espnSwid.isBlank(),
        onClick = onLookup,
      )
    }
  }
}

private fun fantraxOptionMeta(option: FantraxLeagueOption): String =
  listOfNotNull(option.teamName?.let { "Your team: $it" }, option.sport?.let { sportLabel(it) })
    .joinToString(" · ")

// ── Step 2 · Teams (1i) ──

@Composable
private fun TeamsStep(state: WizardState) {
  StepColumn {
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Baseline).justifyContent(JustifyContent.SpaceBetween)
        .gap(10.px).toAttrs()
    ) {
      StepHeading("Who's in?")
      SpanText("${state.teams.size} teams", Modifier.dmStamp().color(DmColor.brass400))
    }

    if (state.importingTeams) {
      Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(8.px).toAttrs()) {
        Cog(size = 18.px, color = DmColor.steel500)
        SpanText(
          if (state.fantraxSelected != null) "Importing the Fantrax league's teams…"
          else "Importing last draft's teams…",
          Modifier.dmStamp().color(DmColor.textMuted),
        )
      }
    } else if (state.teamImportError != null) {
      Toast(
        title = "Couldn't import teams",
        message = state.teamImportError,
        tone = ToastTone.Rust,
        onClose = { state.teamImportError = null },
      )
    }

    if (state.teams.any { it.source == TeamSource.Fantrax }) {
      SpanText(
        "Fantrax knows the team names but not who runs them — add an owner email to each so the " +
          "machine can put them on the clock.",
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).displayBlock(),
      )
    }
    if (state.teams.any { it.source == TeamSource.Espn }) {
      SpanText(
        "ESPN supplied owner names but not email addresses — add the missing emails so " +
          "each manager can sign in and receive alerts.",
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).displayBlock(),
      )
    }

    Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px).toAttrs()) {
      state.teams.forEach { t ->
        // Keyed by localId so editing one row never remounts another's inputs (the DS Input syncs
        // its DOM value at mount only, and a remount mid-typing would drop the caret).
        key(t.localId) {
          if (t.source != TeamSource.Manual) ImportedTeamRow(state, t) else TeamRow(state, t)
        }
      }
    }

    if (state.teamEditorOpen) {
      PanelColumn {
        Div(
          attrs = Modifier.displayFlex().alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.SpaceBetween).gap(8.px).toAttrs()
        ) {
          SpanText("Add a team", Modifier.dmStamp())
          if (state.teams.isNotEmpty()) {
            IconButton(
              icon = "caret-up", label = "Collapse add-team form",
              variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
              onClick = { state.teamEditorOpen = false },
            )
          }
        }
        // The DS Input writes its DOM value only on mount, so remount the fields after each add to
        // clear them (keyed on the team count, which changes exactly when a team is added).
        key(state.teams.size) {
          Input(
            label = "Team name", icon = "shield", placeholder = "Boiler Room Bandits",
            autoFocus = true,
            value = state.formTeamName, onValueChange = { state.formTeamName = it },
            onEnter = { state.animate { addTeam() } },
          )
          Input(
            label = "Owner", icon = "user", placeholder = "Avery Lin",
            value = state.formOwnerName, onValueChange = { state.formOwnerName = it },
            onEnter = { state.animate { addTeam() } },
          )
          Input(
            label = "Owner email", icon = "envelope-simple", type = "email",
            placeholder = "avery.lin@gmail.com",
            value = state.formOwnerEmail, error = state.formOwnerEmailError,
            onValueChange = { state.formOwnerEmail = it; state.formOwnerEmailError = null },
            onEnter = { state.animate { addTeam() } },
          )
        }
        Button(
          "Add team", variant = ButtonVariant.Secondary, icon = "plus", fullWidth = true,
          disabled = !state.canAddTeam(),
          onClick = { state.animate { addTeam() } },
        )
        Divider(label = "or")
        Button(
          "Upload CSV", variant = ButtonVariant.Ghost, icon = "upload-simple", fullWidth = true,
          disabled = state.importingTeams,
          onClick = { state.showCsvUpload = true },
        )
      }
    } else {
      Button(
        "Add or import teams", variant = ButtonVariant.Ghost, icon = "plus-circle", fullWidth = true,
        disabled = state.importingTeams,
        onClick = { state.teamEditorOpen = true },
      )
    }
  }

  val missingOwners = state.teamsMissingOwner()
  StepFooter {
    Button("Back", variant = ButtonVariant.Ghost, icon = "arrow-left", onClick = { state.goTo(WizPhase.League) })
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px).toAttrs()) {
      if (missingOwners > 0) {
        SpanText(
          "$missingOwners missing an email",
          Modifier.dmStamp().color(DmColor.rust300),
        )
      }
      Button(
        "Next · Format", variant = ButtonVariant.Primary, iconRight = "arrow-right",
        disabled = state.importingTeams || state.teams.size < 2 || missingOwners > 0,
        onClick = { state.goTo(WizPhase.Format) },
      )
    }
  }

  Presence(state.showCsvUpload) {
    TeamCsvUploadModal(
      existingEmails = state.existingEmails(),
      onImport = { rows -> state.addTeamsFromCsv(rows) },
      onDismiss = { state.showCsvUpload = false },
    )
  }
}

/** A hand-entered team: name plus owner, both already known, so the row is read-only. */
@Composable
private fun TeamRow(state: WizardState, t: WizardTeam) {
  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).padding(topBottom = 10.px, leftRight = 12.px)
      .border(1.px, LineStyle.Solid, DmColor.border).borderRadius(DmEffects.radiusSm)
      .backgroundColor(DmColor.surfaceInset).transitionRole(TransitionRole.Item).toAttrs()
  ) {
    Avatar(name = t.ownerName, size = AvatarSize.Sm)
    Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
      SpanText(
        t.teamName,
        Modifier.fontFamily(*DmType.body).fontSize(14.px).fontWeight(DmType.weightSemibold)
          .color(DmColor.text).displayBlock(),
      )
      SpanText(
        "${t.ownerName} · ${t.ownerEmail}",
        Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
          .displayBlock().margin(top = 1.px),
      )
    }
    RemoveTeamButton(state, t)
  }
}

/**
 * A team pulled from an external provider. The row keeps owner fields editable because providers
 * do not expose the email identity the app authorizes and notifies on.
 */
@Composable
private fun ImportedTeamRow(state: WizardState, t: WizardTeam) {
  val needsOwner = t.ownerEmail.isBlank()
  Div(
    attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px)
      .padding(topBottom = 10.px, leftRight = 12.px)
      .border(1.px, LineStyle.Solid, if (needsOwner) DmColor.rust600 else DmColor.border)
      .borderRadius(DmEffects.radiusSm).backgroundColor(DmColor.surfaceInset)
      .transitionRole(TransitionRole.Item).toAttrs()
  ) {
    Div(attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px).toAttrs()) {
      Avatar(name = t.ownerName.ifBlank { t.teamName }, size = AvatarSize.Sm)
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        SpanText(
          t.teamName,
          Modifier.fontFamily(*DmType.body).fontSize(14.px).fontWeight(DmType.weightSemibold)
            .color(DmColor.text).displayBlock(),
        )
        Badge(
          label = if (needsOwner) "NEEDS OWNER" else "FROM ${t.source.name.uppercase()}",
          tone = if (needsOwner) BadgeTone.Rust else BadgeTone.Brass,
          modifier = Modifier.margin(top = 3.px),
        )
      }
      RemoveTeamButton(state, t)
    }
    // Ids are per-row: the roster repeats these labels, and the DS default (a slug of the label)
    // would give every row the same id, pointing all 30 labels at the first row's input.
    Input(
      label = "Owner", icon = "user", placeholder = "Avery Lin", size = InputSize.Sm,
      id = "in-owner-${t.localId}",
      value = t.ownerName,
      onValueChange = { name -> state.updateTeam(t.localId) { it.copy(ownerName = name) } },
    )
    Input(
      label = "Owner email", icon = "envelope-simple", type = "email", size = InputSize.Sm,
      placeholder = "avery.lin@gmail.com",
      id = "in-owner-email-${t.localId}",
      value = t.ownerEmail,
      onValueChange = { addr -> state.updateTeam(t.localId) { it.copy(ownerEmail = addr) } },
    )
  }
}

@Composable
private fun RemoveTeamButton(state: WizardState, t: WizardTeam) {
  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).cursor(Cursor.Pointer)
      .toAttrs {
        attr("role", "button"); attr("aria-label", "Remove ${t.teamName}")
        onClick { state.animate { teams = teams.filterNot { it.localId == t.localId } } }
      }
  ) {
    Icon("x", IconWeight.Bold, Modifier.fontSize(16.px).color(DmColor.steel500))
  }
}

// ── Step 3 · Format (1j / 1k) ──

private class FormatOption(
  val order: DraftOrder?,
  val label: String,
  val desc: String,
  val icon: String,
  val disabled: Boolean,
)

private val FORMAT_OPTIONS = listOf(
  FormatOption(DraftOrder.SNAKE, "Snake", "Order reverses every round.", "arrows-clockwise", false),
  FormatOption(DraftOrder.LINEAR, "Linear", "Same order every round.", "arrow-right", false),
  FormatOption(DraftOrder.CUSTOM, "Custom", "Hand-build the pick order yourself.", "sliders", false),
  FormatOption(DraftOrder.LOTTERY, "Lottery", "Weighted draw sets the top of round one.", "dice-five", false),
)

@Composable
private fun FormatStep(state: WizardState) {
  LaunchedEffect(state.teams, state.format) { state.syncFirstRound() }

  StepColumn {
    StepHeading("Set the wheel")

    Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(10.px).toAttrs()) {
      FORMAT_OPTIONS.forEach { opt -> FormatCard(state, opt) }
    }

    PanelColumn(gap = 10.px) {
      Input(
        label = "Rounds", type = "number", icon = "hash", value = state.roundsText,
        onValueChange = { state.setRounds(it) },
      )
      SpanText(
        "${state.teams.size} teams × ${state.rounds} rounds = ${state.teams.size * state.rounds} picks",
        Modifier.dmStamp().color(DmColor.textMuted),
      )
    }

    if (state.format.expandsFirstRound) FirstRoundOrderSection(state)
    if (state.format == DraftOrder.CUSTOM) CustomOrderEditor(state)
    if (state.format == DraftOrder.LOTTERY) LotteryExplainerPanel(state)

    PoolSelector(state)
  }

  Presence(state.poolPickerOpen) {
    PoolPickerModal(
      excludeIds = setOfNotNull(state.selectedPool?.id),
      onPick = { state.selectPool(it); state.poolPickerOpen = false },
      onDismiss = { state.poolPickerOpen = false },
    )
  }

  val canNext = state.rounds in 1..100 && when {
    state.format == DraftOrder.CUSTOM -> state.customOrder.isNotEmpty()
    state.format.expandsFirstRound -> state.customOrder.isNotEmpty() && firstRoundMatches(state.customOrder, state.teams)
    else -> true
  }
  val lottery = state.format == DraftOrder.LOTTERY
  StepFooter {
    Button("Back", variant = ButtonVariant.Ghost, icon = "arrow-left", onClick = { state.goTo(WizPhase.Teams) })
    Button(
      if (lottery) "Next · Set the order" else "Next · Start",
      variant = ButtonVariant.Primary, iconRight = "arrow-right",
      disabled = !canNext,
      onClick = { state.goTo(if (lottery) WizPhase.LotteryWeights else WizPhase.Review) },
    )
  }
}

@Composable
private fun FormatCard(state: WizardState, opt: FormatOption) {
  val order = opt.order
  val selected = !opt.disabled && order != null && state.format == order
  val iconColor = when {
    selected -> DmColor.brass400
    opt.disabled -> DmColor.steel600
    else -> DmColor.textSecondary
  }

  SelectableCard(
    selected = selected,
    onClick = if (!opt.disabled && order != null) ({ state.selectFormat(order) }) else null,
    ariaLabel = opt.label,
    modifier = Modifier
      .padding(topBottom = 13.px, leftRight = 14.px)
      .then(if (opt.disabled) Modifier.border(1.px, LineStyle.Solid, DmColor.border) else Modifier)
      .opacity(if (opt.disabled) 0.55 else 1.0)
      .cursor(if (opt.disabled) Cursor.NotAllowed else Cursor.Pointer),
  ) {
    Icon(opt.icon, IconWeight.Bold, Modifier.fontSize(22.px).color(iconColor).width(26.px).flex("0 0 auto")
      .styleModifier { property("text-align", "center") })
    Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
      SpanText(
        opt.label,
        Modifier.roleH3().fontSize(15.px).displayBlock()
          .color(if (selected) DmColor.brass300 else if (opt.disabled) DmColor.textMuted else DmColor.text),
      )
      SpanText(
        opt.desc,
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted)
          .displayBlock().margin(top = 1.px),
      )
    }
    if (selected) {
      Icon("check-circle", IconWeight.Fill, Modifier.fontSize(22.px).color(DmColor.brass400))
    } else if (opt.disabled) {
      Badge("In the shop", tone = BadgeTone.Neutral, icon = "wrench")
    }
  }
}

// ── Step 3 · optional player pool (pools frame 1h) ──

/**
 * The optional pool selector on the Format step: "No pool — free text" vs the currently selected
 * pool, plus doors to browse every pool or forge a new one (opened in a new tab so the wizard's
 * in-memory state survives).
 */
@Composable
private fun PoolSelector(state: WizardState) {
  SpanText("Player pool · optional", Modifier.dmStamp().margin(top = 6.px))

  SelectableCard(
    selected = state.selectedPool == null,
    onClick = { state.selectPool(null) },
    ariaLabel = "No pool — free text",
    modifier = Modifier.padding(topBottom = 13.px, leftRight = 14.px),
  ) {
    Icon(
      "textbox", IconWeight.Bold,
      Modifier.fontSize(20.px).color(if (state.selectedPool == null) DmColor.brass400 else DmColor.textMuted)
        .width(26.px).flex("0 0 auto").styleModifier { property("text-align", "center") },
    )
    Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
      SpanText(
        "No pool — free text",
        Modifier.roleH3().fontSize(15.px).displayBlock()
          .color(if (state.selectedPool == null) DmColor.brass300 else DmColor.text),
      )
      SpanText(
        "Owners type picks exactly as the league should read them.",
        Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).displayBlock(),
      )
    }
    if (state.selectedPool == null) {
      Icon("check-circle", IconWeight.Fill, Modifier.fontSize(22.px).color(DmColor.brass400))
    }
  }

  state.selectedPool?.let { pool ->
    SelectableCard(
      selected = true,
      onClick = { state.poolPickerOpen = true },
      ariaLabel = pool.name,
      modifier = Modifier.padding(topBottom = 13.px, leftRight = 14.px),
    ) {
      Icon(
        sportIcon(pool.sport), IconWeight.Bold,
        Modifier.fontSize(20.px).color(DmColor.brass400).width(26.px).flex("0 0 auto")
          .styleModifier { property("text-align", "center") },
      )
      Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
        SpanText(pool.name, Modifier.roleH3().fontSize(15.px).color(DmColor.brass300).displayBlock())
        SpanText(
          poolStamp(pool),
          Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted)
            .displayBlock().margin(top = 2.px),
        )
      }
      Icon("check-circle", IconWeight.Fill, Modifier.fontSize(22.px).color(DmColor.brass400))
    }
  }

  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px)
      .padding(topBottom = 12.px, leftRight = 14.px)
      .border(1.px, LineStyle.Solid, DmColor.borderStrong).borderRadius(DmEffects.radiusMd)
      .backgroundColor(DmColor.surfaceInset).cursor(Cursor.Pointer)
      .toAttrs {
        attr("role", "button")
        onClick { state.poolPickerOpen = true }
      }
  ) {
    Icon("rows", IconWeight.Bold, Modifier.fontSize(20.px).color(DmColor.textMuted).width(26.px).flex("0 0 auto")
      .styleModifier { property("text-align", "center") })
    SpanText("Browse all pools", Modifier.roleH3().fontSize(15.px).flex(1).minWidth(0.px))
    Icon("caret-right", IconWeight.Bold, Modifier.fontSize(16.px).color(DmColor.steel500))
  }

  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(12.px)
      .padding(topBottom = 12.px, leftRight = 14.px)
      .border(1.px, LineStyle.Dashed, DmColor.borderStrong).borderRadius(DmEffects.radiusMd)
      .cursor(Cursor.Pointer)
      .toAttrs {
        attr("role", "button")
        onClick { window.open("/pools/new", "_blank") }
      }
  ) {
    Icon("plus-circle", IconWeight.Bold, Modifier.fontSize(20.px).color(DmColor.brass400).width(26.px).flex("0 0 auto")
      .styleModifier { property("text-align", "center") })
    SpanText("Create a new pool", Modifier.roleH3().fontSize(15.px).flex(1).minWidth(0.px))
  }
}

/** "OFFICIAL · 1,696 PLAYERS" stamp under a selected pool's name. */
private fun poolStamp(pool: PlayerPoolResponse): String {
  val prefix = when {
    pool.isOfficial -> "OFFICIAL"
    pool.isPublic -> "COMMUNITY"
    else -> "PRIVATE"
  }
  return "$prefix · ${formatCount(pool.totalPlayerCount)} PLAYERS"
}

private suspend fun fetchOfficialPool(sport: Sport): PlayerPoolResponse? {
  val pools = try {
    apiGet(
      "/api/player-pools?tab=official&sport=${sport.name}",
      ListSerializer(PlayerPoolResponse.serializer()),
    )
  } catch (_: Throwable) {
    emptyList()
  }
  return preferredOfficialPool(sport, pools)
}

internal fun preferredOfficialPool(
  sport: Sport,
  pools: List<PlayerPoolResponse>,
): PlayerPoolResponse? = pools
  .filter { it.isOfficial && it.sport == sport }
  .maxWithOrNull(compareBy<PlayerPoolResponse> { it.totalPlayerCount }.thenBy { it.name })

// ── Step 3 snake/linear · round-1 order ──

/** How a SNAKE or LINEAR draft's round 1 is ordered; every later round is derived from it. */
internal enum class FirstRoundMode { Custom, Random }

@Composable
private fun FirstRoundOrderSection(state: WizardState) {
  SpanText("Round 1 order", Modifier.dmStamp().margin(top = 6.px))

  Div(attrs = Modifier.displayFlex().gap(10.px).toAttrs()) {
    FirstRoundModeCard(state, FirstRoundMode.Custom, "Set it yourself", "list-numbers")
    FirstRoundModeCard(state, FirstRoundMode.Random, "Randomize", "shuffle")
  }

  SpanText(
    if (state.format == DraftOrder.SNAKE) "Later rounds snake off this order, reversing every other round."
    else "Every later round repeats this order.",
    Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted),
  )

  when (state.firstRoundMode) {
    FirstRoundMode.Custom -> CustomOrderEditor(state, firstRoundOnly = true)
    FirstRoundMode.Random -> RandomFirstRound(state)
  }
}

@Composable
private fun FirstRoundModeCard(state: WizardState, mode: FirstRoundMode, label: String, icon: String) {
  val selected = state.firstRoundMode == mode
  SelectableCard(
    selected = selected,
    onClick = { state.selectFirstRoundMode(mode) },
    ariaLabel = label,
    modifier = Modifier.flex(1).minWidth(0.px).padding(topBottom = 11.px, leftRight = 12.px).gap(10.px),
  ) {
    Icon(icon, IconWeight.Bold, Modifier.fontSize(18.px).color(if (selected) DmColor.brass400 else DmColor.textSecondary))
    SpanText(
      label,
      Modifier.roleH3().fontSize(14.px).flex(1).minWidth(0.px)
        .color(if (selected) DmColor.brass300 else DmColor.text),
    )
  }
}

@Composable
private fun RandomFirstRound(state: WizardState) {
  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px).toAttrs()) {
    state.customOrder.forEachIndexed { index, slot ->
      key(slot.id) {
        Div(
          attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px)
            .padding(topBottom = 10.px, leftRight = 12.px)
            .border(1.px, LineStyle.Solid, DmColor.border).borderRadius(DmEffects.radiusSm)
            .backgroundColor(DmColor.surfacePanel).transitionRole(TransitionRole.Item).toAttrs()
        ) {
          SpanText(
            (index + 1).toString().padStart(2, '0'),
            Modifier.fontFamily(*DmType.mono).fontSize(12.px).fontWeight(DmType.weightBold).color(DmColor.textMuted),
          )
          Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
            val team = state.teamFor(slot.teamLocalId)
            SpanText(
              team?.teamName ?: "—",
              Modifier.fontFamily(*DmType.body).fontSize(13.px).fontWeight(DmType.weightSemibold)
                .color(DmColor.text).displayBlock(),
            )
            SpanText(
              team?.ownerName ?: "",
              Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock(),
            )
          }
        }
      }
    }
    Button(
      "Reshuffle", variant = ButtonVariant.Secondary, icon = "shuffle", fullWidth = true,
      disabled = state.teams.size < 2, onClick = { state.animate { reshuffleFirstRound() } },
    )
  }
}

// ── Step 3 custom · per-round order editor (1k) ──

@Composable
internal fun CustomOrderEditor(state: WizardState, firstRoundOnly: Boolean = false) {
  val rounds = state.rounds
  val active = if (firstRoundOnly) 1 else state.activeRound.coerceIn(1, maxOf(1, rounds))

  if (!firstRoundOnly) RoundRail(state, rounds, active)

  val roundIndices = indicesInRound(state.customOrder, active)
  val traded = roundIndices.count { state.customOrder[it].origin == PickOrigin.TRADED }
  val comp = roundIndices.count { state.customOrder[it].origin == PickOrigin.COMPENSATORY }
  val skipped = roundIndices.count { state.customOrder[it].skipped }
  SpanText(
    "Round $active · ${roundIndices.size} picks · $traded traded · $comp comp · $skipped skipped",
    Modifier.dmStamp().color(DmColor.glass300),
  )

  Div(attrs = Modifier.displayFlex().flexDirection(FlexDirection.Column).gap(8.px).toAttrs()) {
    roundIndices.forEachIndexed { rowPos, index ->
      val slot = state.customOrder[index]
      key(slot.id) {
        PickRow(
          position = index + 1,
          teamName = state.teamFor(slot.teamLocalId)?.teamName,
          ownerName = state.teamFor(slot.teamLocalId)?.ownerName,
          origin = slot.origin,
          originTeamName = state.teamFor(slot.originTeamLocalId)?.teamName,
          skipped = slot.skipped,
          reassigning = state.reassigningIndex == index,
          isFirstInRound = rowPos == 0,
          isLastInRound = rowPos == roundIndices.size - 1,
          teams = state.teams,
          onMoveUp = { state.animate { moveUpPick(index) } },
          onMoveDown = { state.animate { moveDownPick(index) } },
          onToggleReassign = { state.reassigningIndex = if (state.reassigningIndex == index) null else index },
          onToggleSkipped = { state.animate { toggleSkippedPick(index) } },
          onSkipFromHere = { state.animate { skipTeamFromPick(index) } },
          onReassign = { newTeamLocalId -> state.animate { reassignPick(index, newTeamLocalId) } },
        )
      }
    }

    // Insert a pick.
    Div(
      attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.Center).gap(8.px)
        .height(44.px).border(1.px, LineStyle.Dashed, DmColor.borderStrong).borderRadius(DmEffects.radiusSm)
        .color(DmColor.textSecondary).fontFamily(*DmType.body).fontSize(13.px).fontWeight(DmType.weightSemibold)
        .cursor(Cursor.Pointer)
        .toAttrs { attr("role", "button"); onClick { state.insertOpen = !state.insertOpen } }
    ) {
      Icon("plus-circle", IconWeight.Bold, Modifier.fontSize(16.px).color(DmColor.brass400))
      Text("Insert a pick")
    }

    if (state.insertOpen) {
      PanelColumn(pad = 12.px, gap = 10.px) {
        Select(
          label = "Compensatory pick for", size = InputSize.Sm,
          onValueChange = { state.insertTeamId = it.ifEmpty { null } },
        ) {
          Option("", attrs = { attr("disabled", "true"); attr("selected", "selected") }) { Text("Choose a team…") }
          state.teams.forEach { t -> Option(t.localId) { Text(t.teamName) } }
        }
        Button(
          "Add compensatory pick", variant = ButtonVariant.Secondary, icon = "plus", fullWidth = true,
          disabled = state.insertTeamId == null,
          onClick = { state.insertTeamId?.let { team -> state.animate { insertCompensatoryPick(active, team) } } },
        )
      }
    }
  }

}

@Composable
private fun RoundRail(state: WizardState, rounds: Int, active: Int) {
  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).justifyContent(JustifyContent.SpaceBetween)
      .gap(10.px).margin(top = 6.px).toAttrs()
  ) {
    SpanText("Pick order", Modifier.dmStamp())
  }

  // Round pill rail.
  Div(
    attrs = Modifier.displayFlex().gap(6.px).alignItems(AlignItems.Center).fillMaxWidth()
      .styleModifier { property("overflow-x", "auto") }.toAttrs()
  ) {
    (1..maxOf(1, rounds)).forEach { r ->
      val on = r == active
      SpanText(
        "R$r",
        Modifier.flex("0 0 auto").padding(topBottom = 5.px, leftRight = 12.px)
          .borderRadius(DmEffects.radiusPill)
          .border(1.px, LineStyle.Solid, if (on) DmColor.brass500 else DmColor.borderStrong)
          .backgroundColor(if (on) DmColor.brassTint(0.14f) else DmColor.surfaceInset)
          .fontFamily(*DmType.mono).fontSize(11.px).fontWeight(DmType.weightBold)
          .color(if (on) DmColor.brass300 else DmColor.textMuted).cursor(Cursor.Pointer)
          .onClick { state.animate { activeRound = r } },
      )
    }
  }
}

@Composable
private fun PickRow(
  position: Int,
  teamName: String?,
  ownerName: String?,
  origin: PickOrigin?,
  originTeamName: String?,
  skipped: Boolean,
  reassigning: Boolean,
  isFirstInRound: Boolean,
  isLastInRound: Boolean,
  teams: List<WizardTeam>,
  onMoveUp: () -> Unit,
  onMoveDown: () -> Unit,
  onToggleReassign: () -> Unit,
  onToggleSkipped: () -> Unit,
  onSkipFromHere: () -> Unit,
  onReassign: (String) -> Unit,
) {
  val comp = origin == PickOrigin.COMPENSATORY
  var skipMenuOpen by remember { mutableStateOf(false) }

  Div(
    attrs = Modifier.displayFlex().alignItems(AlignItems.Center).gap(10.px).padding(topBottom = 10.px, leftRight = 12.px)
      .border(1.px, LineStyle.Solid, if (skipped) DmColor.steel500 else if (comp) DmColor.verde600 else DmColor.border)
      .borderRadius(DmEffects.radiusSm)
      .backgroundColor(if (skipped) DmColor.surfaceInset else if (comp) Color.rgba(69, 140, 111, 0.08f) else DmColor.surfacePanel)
      .transitionRole(TransitionRole.Item)
      .toAttrs()
  ) {
    SpanText(
      position.toString().padStart(2, '0'),
      Modifier.fontFamily(*DmType.mono).fontSize(12.px).fontWeight(DmType.weightBold).color(DmColor.textMuted).flex("0 0 auto"),
    )
    Div(attrs = Modifier.flex(1).minWidth(0.px).toAttrs()) {
      SpanText(
        teamName ?: "—",
        Modifier.fontFamily(*DmType.body).fontSize(13.px).fontWeight(DmType.weightSemibold)
          .color(if (skipped) DmColor.textMuted else DmColor.text).displayBlock(),
      )
      if (skipped) {
        SpanText("Skipped", Modifier.dmStamp().color(DmColor.steel400).displayBlock())
      } else if (reassigning) {
        Select(
          size = InputSize.Sm, modifier = Modifier.margin(top = 4.px),
          onValueChange = { if (it.isNotEmpty()) onReassign(it) },
        ) {
          Option("", attrs = { attr("disabled", "true"); attr("selected", "selected") }) { Text("Reassign to…") }
          teams.forEach { t -> Option(t.localId) { Text(t.teamName) } }
        }
      } else if (origin != null) {
        PickOriginStamp(origin, originTeamName)
      } else {
        SpanText(
          ownerName ?: "",
          Modifier.fontFamily(*DmType.mono).fontSize(11.px).color(DmColor.textMuted).displayBlock(),
        )
      }
    }
    IconButton(
      "caret-up", "Move pick $position up", variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
      disabled = isFirstInRound, onClick = onMoveUp,
    )
    IconButton(
      "caret-down", "Move pick $position down", variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
      disabled = isLastInRound, onClick = onMoveDown,
    )
    IconButton(
      "arrows-left-right", "Reassign pick $position", variant = ButtonVariant.Ghost, size = ButtonSize.Sm,
      onClick = onToggleReassign,
    )
    Div(attrs = Modifier.position(Position.Relative).flex("0 0 auto").toAttrs()) {
      IconButton(
        if (skipped) "arrow-counter-clockwise" else "prohibit", if (skipped) "Restore pick $position" else "Skip pick $position",
        variant = ButtonVariant.Ghost, size = ButtonSize.Sm, onClick = onToggleSkipped,
        onContextMenu = { skipMenuOpen = true }, onLongPress = { skipMenuOpen = true },
      )
      if (skipMenuOpen) {
        Div(
          attrs = Modifier.position(Position.Absolute).zIndex(20).width(180.px)
            .styleModifier { property("right", "0"); property("top", "calc(100% + 4px)") }
            .dmPanel().padding(6.px).toAttrs { attr("role", "menu") }
        ) {
          Button(
            "Skip from here", icon = "prohibit", variant = ButtonVariant.Ghost,
            size = ButtonSize.Sm, fullWidth = true,
            onClick = { skipMenuOpen = false; onSkipFromHere() },
          )
        }
      }
    }
  }
}

// ── Step 4 · Review & start (1l) ──

@Composable
private fun ReviewStep(
  state: WizardState,
  leagues: List<LeagueCardResponse>,
  onStart: () -> Unit,
  onSaveLater: () -> Unit,
) {
  val leagueName = resolvedLeagueName(state, leagues)
  val totalPicks = state.totalPicks()
  val firstTeamName = state.firstPickTeamName()

  StepColumn(gap = 14.px) {
    StepHeading("Ready to start")

    val lottery = state.format == DraftOrder.LOTTERY
    Div(attrs = Modifier.dmPanel().padding(topBottom = 4.px, leftRight = 16.px).toAttrs()) {
      ReviewRow("League", leagueName)
      ReviewRow("Teams", "${state.teams.size} teams")
      ReviewRow(
        "Format",
        if (lottery) "Lottery · ${state.lotterySize} of ${state.teams.size} picks drawn" else formatLabel(state.format),
      )
      if (state.format.expandsFirstRound) {
        ReviewRow("Round 1", if (state.firstRoundMode == FirstRoundMode.Random) "Randomized" else "Set by hand")
      }
      ReviewRow("Rounds", if (lottery) "${state.rounds} · linear after round 1" else state.rounds.toString())
      ReviewRow("Total picks", totalPicks.toString(), last = true)
    }

    if (lottery) state.lotteryState?.let { LotteryDrawnOrderPanel(it) }

    Div(attrs = Modifier.fontFamily(*DmType.body).fontSize(DmType.textSm).color(DmColor.textMuted).lineHeight(1.55).toAttrs()) {
      if (firstTeamName != null) {
        Text("Starting locks the order and emails ")
        SpanText(firstTeamName, Modifier.color(DmColor.textSecondary))
        Text(" their first pick link.")
      } else {
        Text("Starting locks the order and completes the draft immediately because every pick is skipped.")
      }
    }

    Button(
      "Start the draft", variant = ButtonVariant.Primary, size = ButtonSize.Lg, icon = "lightning",
      fullWidth = true, loading = state.submitting, onClick = onStart,
    )
    Button(
      "Save & finish later", variant = ButtonVariant.Ghost, fullWidth = true,
      disabled = state.submitting, onClick = onSaveLater,
    )
  }

  Div(
    attrs = Modifier.displayFlex().justifyContent(JustifyContent.FlexStart).padding(16.px).margin(top = 8.px)
      .borderTop(1.px, LineStyle.Solid, DmColor.border).toAttrs()
  ) {
    Button(
      "Back", variant = ButtonVariant.Ghost, icon = "arrow-left", disabled = state.submitting,
      onClick = {
        state.goTo(if (state.format == DraftOrder.LOTTERY) WizPhase.LotteryOrder else WizPhase.Format)
      },
    )
  }
}

@Composable
private fun ReviewRow(key: String, value: String, last: Boolean = false) {
  Div(
    attrs = Modifier.displayFlex().justifyContent(JustifyContent.SpaceBetween).alignItems(AlignItems.Baseline)
      .gap(12.px).padding(topBottom = 11.px, leftRight = 0.px)
      .then(if (last) Modifier else Modifier.borderBottom(1.px, LineStyle.Solid, DmColor.border))
      .toAttrs()
  ) {
    SpanText(key, Modifier.dmStamp().color(DmColor.textMuted))
    SpanText(
      value,
      Modifier.fontFamily(*DmType.body).fontSize(13.px).fontWeight(DmType.weightSemibold).color(DmColor.text)
        .styleModifier { property("text-align", "right") },
    )
  }
}

// ── Copy / derivation helpers ──

private const val MIXED_SPORT = "MIXED"

private fun currentBrowserYear(): Int = js("new Date().getFullYear()")
private fun currentBrowserMonth(): Int = js("new Date().getMonth()")

private fun defaultEspnSeason(sport: Sport?): Int {
  val year = currentBrowserYear()
  return if (sport in setOf(Sport.NBA, Sport.NHL) && currentBrowserMonth() >= 6) year + 1 else year
}

private fun leagueMeta(card: LeagueCardResponse): String {
  val d = card.latestDraft
  val parts = mutableListOf<String>()
  d?.sport?.let { parts.add(sportLabel(it)) }
  d?.teamCount?.let { parts.add("$it TEAM${if (it == 1) "" else "S"}") }
  parts.add("YOU MANAGE")
  return parts.joinToString(" · ")
}

private fun formatLabel(order: DraftOrder): String = when (order) {
  DraftOrder.SNAKE -> "Snake"
  DraftOrder.LINEAR -> "Linear"
  DraftOrder.CUSTOM -> "Custom"
  DraftOrder.LOTTERY -> "Lottery"
}

private fun resolvedLeagueName(state: WizardState, leagues: List<LeagueCardResponse>): String =
  state.hydratedLeagueName
    ?: state.selectedLeagueId?.let { id -> leagues.firstOrNull { it.league.id == id }?.league?.name }
    ?: state.newLeagueName.trim()

// ── Creation sequence (step 4) ──

private suspend fun runCreation(
  state: WizardState,
  email: String,
  leagues: List<LeagueCardResponse>,
  start: Boolean,
  ctx: PageContext,
) {
  val draftId = ensureEntitiesCreated(state, email, leagues)

  // Order. Lottery drafts skip this — the draw wrote the picks when it committed, and the order
  // step saved any of the LM's adjustments on its way out.
  if (state.format != DraftOrder.LOTTERY) {
    val entries = state.orderEntries(state.plannedOrder())
    apiPost(
      "/api/draft-order",
      apiJson.encodeToString(SetDraftOrderRequest.serializer(), SetDraftOrderRequest(draftId = draftId, entries = entries)),
      SuccessResponse.serializer(),
    )
  }

  // Start (or leave pending) and route out.
  if (start) {
    when (val result = startDraft(draftId)) {
      is StartDraftResult.Success -> ctx.router.transitionTo("/draft/$draftId")
      is StartDraftResult.Failure -> {
        state.errorMsg = result.message
        state.submitting = false
      }
    }
  } else {
    ctx.router.transitionTo("/")
  }
}

/**
 * Persist the wizard's entities (league → pool → draft → teams) exactly once, recording the
 * created draft id and the localId → real-id team map. Safe to call again — subsequent calls
 * return the already-created draft.
 */
private suspend fun ensureEntitiesCreated(
  state: WizardState,
  email: String,
  leagues: List<LeagueCardResponse>,
): String {
  state.createdDraftId?.let { return it }

  // 1. League — reuse the selected one, or create the new one.
  val newLeagueId = if (state.selectedLeagueId != null) null else apiPost(
    "/api/leagues",
    apiJson.encodeToString(CreateLeagueRequest.serializer(), CreateLeagueRequest(state.newLeagueName.trim(), email)),
    LeagueResponse.serializer(),
  ).id
  val leagueId = state.selectedLeagueId ?: newLeagueId!!

  // 1b. Optional external link, only for a league this wizard just created — an existing one is
  // managed from `/league/{id}/settings`.
  val externalConnected = newLeagueId != null && connectExternalLeague(state, newLeagueId)

  // 2. Draft — attached to the optionally selected pool (null = free-text draft).
  val draft = apiPost(
    "/api/drafts",
    apiJson.encodeToString(
      CreateDraftRequest.serializer(),
      CreateDraftRequest(leagueId, state.selectedPool?.id, state.rounds, state.format),
    ),
    DraftResponse.serializer(),
  )

  // 4. Teams — create each with its given owner and attach in parallel; learn the real ids.
  val idMap: Map<String, String> = coroutineScope {
    state.teams.map { t ->
      async {
        t.localId to apiPost(
          "/api/draft-teams",
          apiJson.encodeToString(
            AddTeamToDraftRequest.serializer(),
            AddTeamToDraftRequest(
              draftId = draft.id, teamName = t.teamName.trim(),
              // An imported row can be saved without an owner name (Fantrax doesn't have one and
              // the roster step only insists on the email); the team name stands in for it.
              ownerName = t.ownerName.trim().ifEmpty { t.teamName.trim() },
              ownerEmail = t.ownerEmail.trim(),
              externalTeamId = t.externalTeamId,
            ),
          ),
          TeamResponse.serializer(),
        ).id
      }
    }.awaitAll().toMap()
  }

  state.createdIdMap = idMap
  state.createdDraftId = draft.id
  if (externalConnected) triggerOwnershipSync(leagueId)
  return draft.id
}

/**
 * Save the wizard's external connection against the freshly created league. Deliberately
 * non-fatal: the league and draft are already real by this point, so
 * failing the whole creation over an optional extra would strand the LM in a half-built state. The
 * connection is re-editable at `/league/{id}/settings`.
 *
 * The sync matters even though `POST /api/draft-start` triggers one — a draft saved for later never
 * hits that path, and the background sweep only refreshes leagues with an ACTIVE draft.
 */
private suspend fun connectExternalLeague(state: WizardState, leagueId: String): Boolean {
  if (!state.connectExternal) return false
  val result = when (state.externalProvider) {
    ExternalProvider.FANTRAX -> {
      val option = state.fantraxSelected ?: return false
      val sport = option.sport ?: return false
      saveLeagueConnection(
        leagueId = leagueId,
        provider = ExternalProvider.FANTRAX,
        externalLeagueId = option.leagueId,
        sport = sport,
        userSecretId = state.fantraxSecret.trim().ifEmpty { null },
      )
    }
    ExternalProvider.ESPN -> {
      val preview = state.espnSelected ?: return false
      saveLeagueConnection(
        leagueId = leagueId,
        provider = ExternalProvider.ESPN,
        externalLeagueId = preview.leagueId,
        externalSeason = preview.season,
        sport = preview.sport,
        espnS2 = state.espnS2.trim(),
        espnSwid = state.espnSwid.trim(),
      )
    }
  }
  if (result is SaveConnectionResult.Failure) {
    console.warn("Couldn't connect the external league: ${result.message}")
    return false
  }
  return true
}

// ── Wizard state ──

internal class WizardState {
  var phase by mutableStateOf(WizPhase.League)

  // Step 1
  var selectedLeagueId by mutableStateOf<String?>(null)
  var creatingNew by mutableStateOf(false)
  var newLeagueName by mutableStateOf("")
  var newLeagueSport by mutableStateOf<Sport?>(null)
  // What an external pick last wrote into the two fields above, so a second pick can replace its own
  // values without ever overwriting something the LM typed. Bumping the nonce remounts the name
  // Input (which reads its DOM value at mount) so a programmatic fill is actually visible.
  private var autoFilledLeagueName by mutableStateOf<String?>(null)
  private var autoFilledSport by mutableStateOf<Sport?>(null)
  var leagueFormNonce by mutableStateOf(0)
    private set
  // A linked league's known sport must not overwrite a partially configured new-league form.
  var linkedLeagueSport by mutableStateOf<Sport?>(null)
    private set

  // Step 1 · optional external link for the new league. Held locally until the league exists.
  var connectExternal by mutableStateOf(false)
  var externalProvider by mutableStateOf(ExternalProvider.FANTRAX)
  var fantraxSecret by mutableStateOf("")
  var fantraxOptions by mutableStateOf<List<FantraxLeagueOption>>(emptyList())
  var fantraxLooking by mutableStateOf(false)
  var fantraxLookupError by mutableStateOf<String?>(null)
  var fantraxSelected by mutableStateOf<FantraxLeagueOption?>(null)
  var espnLeagueId by mutableStateOf("")
  var espnSeasonText by mutableStateOf(defaultEspnSeason(null).toString())
  var espnS2 by mutableStateOf("")
  var espnSwid by mutableStateOf("")
  var espnLooking by mutableStateOf(false)
  var espnLookupError by mutableStateOf<String?>(null)
  var espnSelected by mutableStateOf<EspnLeaguePreview?>(null)
  private var espnSeasonDirty = false
  private var espnLookupGeneration = 0

  // Step 2
  var teams by mutableStateOf<List<WizardTeam>>(emptyList())
  private var nextLocalId by mutableStateOf(0)
  var formTeamName by mutableStateOf("")
  var formOwnerName by mutableStateOf("")
  var formOwnerEmail by mutableStateOf("")
  var formOwnerEmailError by mutableStateOf<String?>(null)
  var importingTeams by mutableStateOf(false)
  var teamImportError by mutableStateOf<String?>(null)
  var showCsvUpload by mutableStateOf(false)
  var teamEditorOpen by mutableStateOf(true)

  // Step 3 — optional player pool (null = free-text draft)
  var selectedPool by mutableStateOf<PlayerPoolResponse?>(null)
    private set
  private var poolSelectionWasManual = false
  private var automaticPoolSource: AutomaticPoolSource? = null
  var poolPickerOpen by mutableStateOf(false)

  // Step 3
  var format by mutableStateOf(DraftOrder.SNAKE)
  var roundsText by mutableStateOf("12")
  // CUSTOM: the whole hand-built order. SNAKE/LINEAR: round 1 only, expanded by [plannedOrder].
  var customOrder by mutableStateOf<List<OrderSlot>>(emptyList())
  var firstRoundMode by mutableStateOf(FirstRoundMode.Custom)
    private set
  var activeRound by mutableStateOf(1)
  var reassigningIndex by mutableStateOf<Int?>(null)
  var insertOpen by mutableStateOf(false)
  var insertTeamId by mutableStateOf<String?>(null)

  // Lottery (format LOTTERY only). Weights are keyed by team localId so they travel with a team
  // when it's reordered across the lottery line.
  var lotteryBaseOrder by mutableStateOf<List<String>>(emptyList())
  var lotterySize by mutableStateOf(0)
  var lotteryWeights by mutableStateOf<Map<String, Int>>(emptyMap())
  private var weightsDirty by mutableStateOf(false)

  // Set once "Process the lottery" persists the wizard's entities; from then on the earlier steps
  // (league/teams/rounds) are locked because they're written to the server.
  var createdDraftId by mutableStateOf<String?>(null)
  var createdIdMap by mutableStateOf<Map<String, String>>(emptyMap())
  var lotteryState by mutableStateOf<LotteryStateResponse?>(null)
  // Server-provided league display name for the resume flow, where no league form was ever filled.
  var hydratedLeagueName by mutableStateOf<String?>(null)

  // The order as the server last confirmed it, so the post-lottery editor can tell an actual
  // adjustment from a reload of the same sequence. Comparing against it (rather than tracking an
  // edited flag) keeps a Back-and-forward trip from re-posting an unchanged order.
  var lotteryOrderBaseline by mutableStateOf<List<OrderSlot>>(emptyList())
  val lotteryOrderDirty: Boolean get() = !sameOrder(customOrder, lotteryOrderBaseline)

  // Step 4
  var submitting by mutableStateOf(false)
  var errorMsg by mutableStateOf<String?>(null)

  val rounds: Int get() = roundsText.toIntOrNull() ?: 0

  fun canAddTeam(): Boolean =
    !importingTeams && formTeamName.isNotBlank() && formOwnerName.isNotBlank() && formOwnerEmail.isNotBlank()

  fun addTeam() {
    if (!canAddTeam()) return
    if (!isValidEmail(formOwnerEmail)) {
      formOwnerEmailError = "Enter a valid email address"
      return
    }
    teams = teams + WizardTeam("t${nextLocalId}", formTeamName.trim(), formOwnerName.trim(), formOwnerEmail.trim())
    nextLocalId += 1
    formTeamName = ""; formOwnerName = ""; formOwnerEmail = ""
  }

  /** Lowercased owner emails already on the roster — used by the CSV modal to reject duplicates. */
  fun existingEmails(): Set<String> =
    teams.mapNotNull { it.ownerEmail.trim().lowercase().ifEmpty { null } }.toSet()

  /** Append CSV-parsed teams to the roster (fresh localIds), returning how many were added. */
  fun addTeamsFromCsv(rows: List<ParsedTeamRow>): Int {
    teams = teams + rows.map { WizardTeam("t${nextLocalId++}", it.teamName, it.ownerName, it.ownerEmail) }
    return rows.size
  }

  private fun invalidateEspnLookup() {
    espnLookupGeneration += 1
    espnLooking = false
    espnLookupError = null
  }

  fun setEspnLeagueId(value: String) {
    if (espnLeagueId != value) invalidateEspnLookup()
    espnLeagueId = value
  }

  fun setEspnS2(value: String) {
    if (espnS2 != value) invalidateEspnLookup()
    espnS2 = value
  }

  fun setEspnSwid(value: String) {
    if (espnSwid != value) invalidateEspnLookup()
    espnSwid = value
  }

  fun beginEspnLookup(
    leagueId: String,
    sport: Sport,
    season: Int,
    espnS2: String,
    espnSwid: String,
  ): EspnLookupRequest {
    espnLookupGeneration += 1
    espnLooking = true
    espnLookupError = null
    return EspnLookupRequest(espnLookupGeneration, leagueId, sport, season, espnS2, espnSwid)
  }

  fun isEspnLookupCurrent(request: EspnLookupRequest): Boolean = request.matches(
    currentGeneration = espnLookupGeneration,
    enabled = connectExternal,
    provider = externalProvider,
    leagueId = espnLeagueId,
    sport = newLeagueSport,
    season = espnSeasonText.toIntOrNull(),
    espnS2 = espnS2,
    espnSwid = espnSwid,
  )

  fun finishEspnLookup(request: EspnLookupRequest) {
    if (request.generation == espnLookupGeneration) espnLooking = false
  }

  /**
   * Toggle the optional external link. Turning it off drops credentials as well as the pick —
   * leaving them in memory for a link the LM just declined is gratuitous.
   */
  fun setConnectExternal(on: Boolean) {
    connectExternal = on
    if (!on) {
      fantraxSecret = ""
      fantraxOptions = emptyList()
      fantraxLookupError = null
      clearFantraxLeague()
      espnLeagueId = ""
      espnS2 = ""
      espnSwid = ""
      espnLookupError = null
      clearEspnLeague()
    }
  }

  fun selectExternalProvider(provider: ExternalProvider) {
    if (externalProvider == provider) return
    clearFantraxLeague()
    clearEspnLeague()
    fantraxSecret = ""
    fantraxOptions = emptyList()
    espnLeagueId = ""
    espnS2 = ""
    espnSwid = ""
    externalProvider = provider
  }

  fun setLeagueSport(sport: Sport?) {
    if (newLeagueSport != sport) invalidateEspnLookup()
    newLeagueSport = sport
    if (!espnSeasonDirty) espnSeasonText = defaultEspnSeason(sport).toString()
    if (espnSelected?.sport != sport) clearEspnLeague()
  }

  fun setEspnSeason(value: String) {
    if (espnSeasonText != value) invalidateEspnLookup()
    espnSeasonDirty = true
    espnSeasonText = value
    espnLookupError = null
    if (espnSelected?.season?.toString() != value.trim()) clearEspnLeague()
  }

  /** Pick a Fantrax league to link; the page's import effect fires off this and seeds the roster. */
  fun selectFantraxLeague(option: FantraxLeagueOption) {
    if (fantraxSelected?.leagueId == option.leagueId) return

    // Fill the league form from the pick — the name and sport are exactly what the LM would have
    // typed. Only touch fields nobody has edited: blank, or still holding the last pick's value.
    if (newLeagueName.isBlank() || newLeagueName == autoFilledLeagueName) {
      newLeagueName = option.leagueName
      autoFilledLeagueName = option.leagueName
      // The DS Input syncs its DOM value at mount only, so remount it to show the filled name.
      leagueFormNonce += 1
    }
    if (newLeagueSport == null || newLeagueSport == autoFilledSport) {
      newLeagueSport = option.sport
      autoFilledSport = option.sport
    }

    fantraxSelected = option
    teams = teams.filter { it.source != TeamSource.Fantrax }
    customOrder = emptyList()
    teamImportError = null
    importingTeams = true
  }

  /** Drop the picked league and every team that came from it, leaving hand-entered teams alone. */
  fun clearFantraxLeague() {
    fantraxSelected = null
    teams = teams.filter { it.source != TeamSource.Fantrax }
    customOrder = emptyList()
    importingTeams = false
    teamImportError = null
  }

  fun selectEspnLeague(preview: EspnLeaguePreview, selfEmail: String) {
    if (newLeagueName.isBlank() || newLeagueName == autoFilledLeagueName) {
      newLeagueName = preview.leagueName
      autoFilledLeagueName = preview.leagueName
      leagueFormNonce += 1
    }
    newLeagueSport = preview.sport
    autoFilledSport = preview.sport
    espnLeagueId = preview.leagueId
    espnSeasonText = preview.season.toString()
    espnSelected = preview
    teams = teams.filter { it.source != TeamSource.Espn } + preview.teams.map { option ->
      WizardTeam(
        localId = "t${nextLocalId++}",
        teamName = option.teamName,
        ownerName = option.ownerNames.joinToString(" & "),
        ownerEmail = if (option.credentialOwner) selfEmail else "",
        source = TeamSource.Espn,
        externalTeamId = option.teamId,
      )
    }
    customOrder = emptyList()
    importingTeams = false
    teamImportError = null
    teamEditorOpen = preview.teams.isEmpty()
  }

  fun applyImportedEspnPool(
    externalLeagueId: String,
    sport: Sport,
    pool: PlayerPoolResponse?,
  ) {
    if (espnSelected?.leagueId != externalLeagueId || espnSelected?.sport != sport) return
    selectAutomaticPool(pool, AutomaticPoolSource.ImportedEspn)
  }

  fun applyLinkedEspnDefaults(
    leagueId: String,
    sport: Sport,
    pool: PlayerPoolResponse?,
  ) {
    if (selectedLeagueId != leagueId || creatingNew) return
    linkedLeagueSport = sport
    selectAutomaticPool(pool, AutomaticPoolSource.LinkedEspn)
  }

  private fun selectAutomaticPool(pool: PlayerPoolResponse?, source: AutomaticPoolSource) {
    if (poolSelectionWasManual) return
    selectedPool = pool
    automaticPoolSource = pool?.let { source }
  }

  fun selectPool(pool: PlayerPoolResponse?) {
    selectedPool = pool
    poolSelectionWasManual = true
    automaticPoolSource = null
  }

  private fun clearAutomaticPool(source: AutomaticPoolSource) {
    if (automaticPoolSource != source) return
    selectedPool = null
    automaticPoolSource = null
  }

  fun clearEspnLeague() {
    invalidateEspnLookup()
    espnSelected = null
    clearAutomaticPool(AutomaticPoolSource.ImportedEspn)
    teams = teams.filter { it.source != TeamSource.Espn }
    customOrder = emptyList()
    importingTeams = false
    teamImportError = null
  }

  /**
   * Seed the roster from a Fantrax league. Fantrax has no owner name or email for a team, so each
   * row lands owner-less and step 2 collects that; [selfEmail] pre-fills the one team the lookup
   * said belongs to the signed-in LM.
   */
  fun finishFantraxTeamImport(leagueId: String, imported: List<FantraxTeamOption>, selfEmail: String) {
    if (fantraxSelected?.leagueId != leagueId) return
    val ownTeamName = fantraxSelected?.teamName?.trim()
    teams = teams.filter { it.source != TeamSource.Fantrax } + imported.map { option ->
      WizardTeam(
        localId = "t${nextLocalId++}",
        teamName = option.teamName,
        ownerName = "",
        ownerEmail = if (ownTeamName != null && option.teamName.trim() == ownTeamName) selfEmail else "",
        source = TeamSource.Fantrax,
        externalTeamId = option.teamId,
      )
    }
    importingTeams = false
    // With a roster on screen the add-team form is in the way; it's one tap to reopen.
    teamEditorOpen = imported.isEmpty()
  }

  fun failFantraxTeamImport(leagueId: String, message: String) {
    if (fantraxSelected?.leagueId != leagueId) return
    importingTeams = false
    teamImportError = message
  }

  /** Edit one team in place — the roster rows for imported teams write their owner fields here. */
  fun updateTeam(localId: String, transform: (WizardTeam) -> WizardTeam) {
    teams = teams.map { if (it.localId == localId) transform(it) else it }
  }

  /**
   * Teams that still need an owner email. An email is the identity the app authorizes and notifies
   * on, so it is the one field providers cannot supply and the draft cannot do without; an owner
   * *name* left blank falls back to the team name at creation.
   */
  fun teamsMissingOwner(): Int = teams.count { it.ownerEmail.isBlank() }

  fun selectExistingLeague(leagueId: String, hasPreviousDraft: Boolean) {
    if (selectedLeagueId == leagueId && !creatingNew) return
    clearLinkedEspnDefaults()
    selectedLeagueId = leagueId
    creatingNew = false
    setConnectExternal(false)
    teams = emptyList()
    customOrder = emptyList()
    importingTeams = hasPreviousDraft
    teamImportError = null
    teamEditorOpen = false
  }

  fun selectNewLeague() {
    clearLinkedEspnDefaults()
    selectedLeagueId = null
    creatingNew = true
    teams = emptyList()
    customOrder = emptyList()
    importingTeams = false
    teamImportError = null
    teamEditorOpen = true
  }

  private fun clearLinkedEspnDefaults() {
    linkedLeagueSport = null
    clearAutomaticPool(AutomaticPoolSource.LinkedEspn)
  }

  fun finishTeamImport(leagueId: String, imported: List<TeamResponse>) {
    if (selectedLeagueId != leagueId) return
    teams = imported.map { team ->
      WizardTeam("t${nextLocalId++}", team.teamName, team.ownerName, team.ownerEmail)
    }
    importingTeams = false
  }

  fun failTeamImport(leagueId: String, message: String) {
    if (selectedLeagueId != leagueId) return
    importingTeams = false
    teamImportError = message
  }

  fun teamFor(localId: String?): WizardTeam? = localId?.let { id -> teams.firstOrNull { it.localId == id } }

  private enum class AutomaticPoolSource { ImportedEspn, LinkedEspn }

  fun selectFormat(order: DraftOrder) {
    // Snake and linear share the same round 1, so flipping between them keeps the LM's edits.
    val keepFirstRound = format.expandsFirstRound && order.expandsFirstRound
    format = order
    resetOrderEditing()
    // A hand-built CUSTOM order must not survive a switch to another format — LOTTERY reuses
    // customOrder for the LM's pass over the drawn order, and a leftover would stand in for it.
    if (!keepFirstRound) customOrder = emptyList()
    lotteryOrderBaseline = emptyList()
    syncFirstRound()
    if (order == DraftOrder.CUSTOM) customOrder = seedCustomOrder(teams, rounds)
    if (order == DraftOrder.LOTTERY) seedLotteryDefaults()
  }

  private fun resetOrderEditing() {
    activeRound = 1
    reassigningIndex = null
    insertOpen = false
    insertTeamId = null
  }

  /** Reseed a SNAKE/LINEAR round 1 that no longer matches the roster (or was never seeded). */
  fun syncFirstRound() {
    if (!format.expandsFirstRound || (customOrder.isNotEmpty() && firstRoundMatches(customOrder, teams))) return
    customOrder = if (firstRoundMode == FirstRoundMode.Random) randomFirstRound(teams) else seedFirstRound(teams)
    resetOrderEditing()
  }

  /**
   * Switching to Random draws a fresh order; switching back to Custom keeps whatever is on screen,
   * so a drawn order can be used as the starting point for hand edits.
   */
  fun selectFirstRoundMode(mode: FirstRoundMode) {
    if (firstRoundMode == mode) return
    firstRoundMode = mode
    if (mode == FirstRoundMode.Random) reshuffleFirstRound()
  }

  fun reshuffleFirstRound() {
    customOrder = randomFirstRound(teams)
    resetOrderEditing()
  }

  /** The full pick sequence the wizard will persist, for every format but LOTTERY. */
  fun plannedOrder(): List<OrderSlot> = when {
    format == DraftOrder.CUSTOM -> customOrder
    format.expandsFirstRound -> expandFirstRound(format, customOrder, rounds)
    else -> emptyList()
  }

  // ── Lottery setup ──

  fun seedLotteryDefaults() {
    lotteryBaseOrder = teams.map { it.localId }
    lotterySize = teams.size
    weightsDirty = false
    reseedWeights()
  }

  /**
   * Recompute the weight map for the current lottery membership. Until the LM touches a weight,
   * defaults descend by slot (slot 1 of L gets L … slot L gets 1); after that, values stick for
   * every team — including ones moved below the line, so their weights survive a round trip
   * across it — and teams without a stored value default to 1 via [weightOf].
   */
  private fun reseedWeights() {
    if (!weightsDirty) {
      lotteryWeights = lotteryBaseOrder.take(lotterySize)
        .mapIndexed { index, id -> id to (lotterySize - index) }.toMap()
    }
  }

  /** A team's effective lottery weight — the single home of the "missing weight = 1" default. */
  fun weightOf(localId: String): Int = lotteryWeights[localId] ?: 1

  fun setLotterySize(size: Int) {
    lotterySize = size.coerceIn(2, maxOf(2, teams.size))
    reseedWeights()
  }

  fun moveLotteryTeam(index: Int, delta: Int) {
    val target = index + delta
    if (index !in lotteryBaseOrder.indices || target !in lotteryBaseOrder.indices) return
    lotteryBaseOrder = lotteryBaseOrder.toMutableList().also {
      it[index] = it[target].also { swapped -> it[target] = it[index] }
    }
    reseedWeights()
  }

  fun adjustLotteryWeight(localId: String, delta: Int) {
    weightsDirty = true
    lotteryWeights = lotteryWeights + (localId to maxOf(1, weightOf(localId) + delta))
  }

  fun lotteryTotalWeight(): Int = lotteryBaseOrder.take(lotterySize).sumOf { weightOf(it) }

  /**
   * Rebuild the wizard around a server-persisted lottery (resume flow). Real team ids double as
   * localIds with an identity id-map, so the rest of the wizard works unchanged. The league is
   * carried as a display name only — the draft already owns its league link server-side.
   */
  fun hydrateFromLottery(lottery: LotteryStateResponse) {
    val ordered = lottery.entries.sortedBy { it.baseOrder }
    teams = ordered.map { WizardTeam(it.teamId, it.teamName, it.ownerName, "") }
    createdIdMap = ordered.associate { it.teamId to it.teamId }
    createdDraftId = lottery.draftId
    selectedLeagueId = null
    creatingNew = false
    hydratedLeagueName = lottery.leagueName
    roundsText = lottery.rounds.toString()
    format = DraftOrder.LOTTERY
    lotteryBaseOrder = ordered.map { it.teamId }
    lotterySize = lottery.lotterySize
    lotteryWeights = ordered.filter { it.weight != null }.associate { it.teamId to it.weight!! }
    weightsDirty = true
    lotteryState = lottery
    phase = WizPhase.LotteryProcessing
  }

  fun setRounds(text: String) {
    roundsText = text
    if (format == DraftOrder.CUSTOM) {
      customOrder = seedCustomOrder(teams, rounds)
      activeRound = activeRound.coerceIn(1, maxOf(1, rounds))
    }
  }

  /** Load the server's committed lottery order into the editor and mark it as the saved baseline. */
  fun seedLotteryOrder(picks: List<PickResponse>) {
    val localIdOf = createdIdMap.entries.associate { (localId, teamId) -> teamId to localId }
    customOrder = orderSlotsFrom(picks, teams.size, localIdOf)
    lotteryOrderBaseline = customOrder
    activeRound = 1
    reassigningIndex = null
    insertOpen = false
    insertTeamId = null
  }

  /** Resolve [slots]' client-side localIds to the persisted team ids the order endpoint expects. */
  fun orderEntries(slots: List<OrderSlot>): List<OrderEntry> = slots.map { slot ->
    OrderEntry(
      teamId = createdIdMap.getValue(slot.teamLocalId),
      round = slot.round,
      originTeamId = slot.originTeamLocalId?.let { createdIdMap[it] },
      origin = slot.origin,
      skipped = slot.skipped,
    )
  }

  fun moveUpPick(index: Int) { customOrder = moveUp(customOrder, index) }
  fun moveDownPick(index: Int) { customOrder = moveDown(customOrder, index) }
  fun toggleSkippedPick(index: Int) { customOrder = toggleSkipped(customOrder, index) }
  fun skipTeamFromPick(index: Int) { customOrder = skipTeamFrom(customOrder, index) }

  fun reassignPick(index: Int, newLocalId: String) {
    customOrder = reassign(customOrder, index, newLocalId)
    reassigningIndex = null
  }

  fun insertCompensatoryPick(round: Int, teamLocalId: String) {
    customOrder = insertCompensatory(customOrder, round, teamLocalId)
    insertOpen = false
    insertTeamId = null
  }

  // A lottery's order is only in customOrder once the post-draw editor has loaded it, so both
  // summaries fall back to the draw itself until then.
  fun totalPicks(): Int = when {
    format == DraftOrder.LOTTERY && customOrder.isNotEmpty() -> customOrder.size
    format == DraftOrder.LOTTERY -> teams.size * rounds
    else -> plannedOrder().size
  }

  fun firstPickTeamName(): String? = when (format) {
    DraftOrder.CUSTOM, DraftOrder.SNAKE, DraftOrder.LINEAR ->
      plannedOrder().firstOrNull { !it.skipped }?.let { teamFor(it.teamLocalId)?.teamName }
    // Once the order is loaded it is the answer, including when every pick is skipped and nobody
    // is on the clock — falling back to the draw there would promise a first-pick email that the
    // backend, which sees a fully resolved order, is never going to send.
    DraftOrder.LOTTERY ->
      if (customOrder.isEmpty()) lotteryState?.entries?.firstOrNull { it.drawSlot == 1 }?.teamName
      else customOrder.firstOrNull { !it.skipped }?.let { teamFor(it.teamLocalId)?.teamName }
  }
}
